export default __webpack_public_path__ + "data/pilot_regions.geojson";